import { render } from "./AddressValue.vue?vue&type=template&id=3cdffb26"
import script from "./AddressValue.vue?vue&type=script&lang=js"
export * from "./AddressValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__